module.exports = __webpack_public_path__ + "img/ch28.9df1e4f8.jpg";